import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import { withRouter } from 'react-router';
import Select from './dev/Select'
import contact_index from './assets/img/contact_index.jpg'
import video from './assets/img/responsive.svg'
import match from './assets/img/social-network.svg'
import social from './assets/img/social-media-marketing.svg'

const { REACT_APP_URI = '/' } = process.env

class Contact extends Component {
    constructor(props) {
        super(props)
        this.state = {
            condition: 'input',
            request: {
                name: '',
                email: '',
                company: '',
                website: '',
                type: '',
                content: '',
            },
            items: [
                { key: 'name', labelID: 'contact_name', required: true, isBlank: '', },
                { key: 'email', labelID: 'contact_email', required: true, isBlank: '', },
                { key: 'company', labelID: 'contact_company', required: true, isBlank: '', },
                { key: 'website', labelID: 'contact_website', },
                { key: 'type', labelID: 'contact_type', required: true, isBlank: '', select: true },
                { key: 'content', labelID: 'contact_content', required: true, isBlank: '', textarea: true },
            ],
            error: '',
        }
    }
    contactInput = key => e => this.setState({ request: { ...this.state.request, [key]: e.target.value } })
    contactSelect = ({ value = '' }) => this.setState({ request: { ...this.state.request, type: value } })
    contactSubmit = () => {
        const { token } = this.props.user
        const { request } = this.state
        fetch(`${REACT_APP_URI}/contactUs/`, {
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": token,
            },
            body: JSON.stringify({ ...request })
        })
            .then(res => {
                console.log(res)
            })
    }
    checkBlank = () => {
        const items = this.state.items.map(item => {
            const { key, required } = item
            const { request } = this.state
            if (required) {
                if (request[key] === '') {
                    return { ...item, isBlank: true }
                }
                else return { ...item, isBlank: false }
            }
            return item
        })
        this.setState({ items },() => {
            if (this.state.items.find(i => i.isBlank) === undefined) this.setState({ condition: 'submit' })
        })
    }
    render() {
        const { contactInput, contactSubmit, contactSelect, checkBlank } = this
        const { condition, request, items } = this.state
        const { messages } = this.props
        const type = [
            { value: messages.contact_influencer, label: messages.contact_influencer, clearableValue: false },
            { value: messages.contact_pricing, label: messages.contact_pricing, clearableValue: false },
            { value: messages.contact_account, label: messages.contact_account, clearableValue: false },
            //{ value: messages.contact_social, label: messages.contact_social, clearableValue: false },
            //{ value: messages.contact_youtube, label: messages.contact_youtube, clearableValue: false },
            { value: messages.contact_other, label: messages.contact_other, clearableValue: false },
        ]
        const renderItems = ({ key, labelID, required, isBlank, textarea, select }) => {
            return (
                <Contnet>
                    <SubTitle>
                        <div>{messages[labelID]}：</div>
                        {condition === 'input' && required && <Required>＊{isBlank && messages.contact_blank}</Required>}
                    </SubTitle>
                    {condition === 'input' && [
                        textarea &&
                        <Textarea onChange={contactInput(key)}
                            value={request[key]}
                            type="text" placeholder={''} />,
                        select &&
                        <SelectWrap>
                            <CategorySelect
                                name="form-field-name"
                                // value={request[key]}
                                onChange={contactSelect}
                                options={type}
                                placeholder={'Select'}
                                id='type'
                            />
                        </SelectWrap>
                        ,
                        !textarea && !select &&
                        <Input onChange={contactInput(key)}
                            value={request[key]}
                            type="text" placeholder={''} />
                    ]}
                    {condition === 'submit' && <SubTitle submit>{request[key]}</SubTitle>}
                </Contnet>
            )
        }
        const renderRequest = () => {
            return (
                <Container>
                    <IndexPicture picture={contact_index}>
                        <FunctionWrap>
                            <Function>
                                <FunctionPicture picture={video} />
                                <FunctionTitle marginTop={'8px'}>{messages.contact_service_marketing}</FunctionTitle>
                            </Function>
                            <Function>
                                <FunctionPicture picture={match} />
                                <FunctionTitle marginTop={'8px'}>{messages.contact_service_creator}</FunctionTitle>
                            </Function>
                            <Function>
                                <FunctionPicture picture={social} />
                                <FunctionTitle marginTop={'8px'}>{messages.contact_service_planning}</FunctionTitle>
                            </Function>
                        </FunctionWrap>
                        <IndexContent>
                            {messages.contact_index}
                        </IndexContent>
                    </IndexPicture>
                    <ContentWrap>
                        <TitleWrap>
                            <Title>{messages.contact_us}</Title>
                            <SubTitle>Email : service@intered.co</SubTitle>
                        </TitleWrap>
                        {items.map(i => renderItems(i))}
                        <Footer>
                            {condition === 'input' && <Button onClick={() => checkBlank()}>{messages.contact_confirm}</Button>}
                            {condition === 'submit' &&
                                [<Button onClick={() => this.setState({ condition: 'input' })} back>{messages.contact_back}</Button>
                                    , <Button onClick={() => { this.setState({ condition: 'response' }) ; contactSubmit()}}>{messages.contact_submit}</Button>]}
                        </Footer>
                    </ContentWrap>
                </Container>

            )
        }
        const renderResponse = () => {
            return (
                <Container response>
                    <Title success>{messages.contact_success}</Title>
                    <SubTitle wait>{messages.contact_wait}</SubTitle>
                    <SubTitle red onClick={() => window.location.reload()}>{messages.contact_again}</SubTitle>
                </Container>
            )
        }
        return (
            <Wrap>
                {condition === 'response'
                    ? renderResponse()
                    : renderRequest()
                }
            </Wrap>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    }
}
export default withRouter(connect(mapStateToProps)(Contact));
const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    min-width: 900px;
    padding: 50px 0 120px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
    font-size: 16px;
    font-weight: 300;
    color: #787878;
    @media (max-width: 900px){
        min-width: 320px;
    }
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 900px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
    @media (max-width: 900px){
        width: calc(100% - 40px);
        margin: 0 20px;
    } 
    @media (max-width: 900px){
        padding: 0px;
    }
    ${({ response }) => response ? 'align-items: center; justify-content: center; padding:82px 0px;': ''};
`
const Title = styled.div`
    font-size: 36px;
    font-weight: 500;
    color: #787878;
    text-align: ${({ success }) => success ? 'center' : ''};
`
const TitleWrap = styled.div`
    display: flex;
    flex-direction : column;
    margin-bottom: 18px;
`

const SubTitle = styled.div`
    display: flex;
    align-items: center;
    text-align: ${({ wait }) => wait ? 'center' : ''};
    padding-top:${({ wait }) => wait ? '20px' : ''};
    font-weight : ${({ submit }) => submit ? '500' : ''};
    color: ${({ red }) => red ? '#de0606' : ''};
    cursor: ${({ red }) => red ? 'pointer' : ''};
    margin-top: ${({ red }) => red ? '20px' : ''};
`

const Contnet = styled.div`
    display: inline-block;
    margin-bottom: 8px;
`
const Input = styled.input`
    width: 100%;
    padding-left: 5px;
    border: solid 1px #dedede;
    font-size: 14px;
    font-weight: 300;
    color: #999999;
    margin-bottom: 8px;
    &:focus {
        border: solid 1px #999999;
        outline: none;
    }
`
const SelectWrap = styled.div`
    display: flex;
    align-items: center;
`
const Textarea = styled.textarea`
    width: 100%;
    border: solid 1px #dedede;
    &:focus {
        border: solid 1px #999999;
        outline: none;
    }
    box-sizing: border-box;
`
const Required = styled.div`
    padding-left: 5px;
    font-size: 14px;
    color: #de0606;
`
const Button = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 0 5px;
    margin-left: 15px;
    background-color: ${props => props.back ? '#a0a0a0' : '#e94242'};
    opacity: .8;
    box-shadow: 0 1px 2px 0 rgba(153, 153, 153, 0.6);
    color: #fff;
    cursor: pointer;
    &:hover {
        opacity: 1;
    }
    &:focus {
        outline: 0;
    }
    @media (max-width: 900px){
        font-size: 16px;
    } 
`
const Footer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding: 0 30%;
`
const CategorySelect = styled(Select)`
    .select__control {
        min-height: 30px;
        border-radius: 0;
    }
    .select__value-container {
        padding: 0 8px;
    }
    .select__dropdown-indicator {
        padding: 0 4px;
    }
`

const IndexPicture = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    width: 100%;
    height: 400px;
    background-position:  50% 35%;;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: ${props => `url(${props.picture})`};
    @media (max-width: 768px){
        max-height: 280px;
        background-size: cover;

    }
`

const IndexContent = styled.div`
    padding : 16px 80px;
    width : 100%;
    text-align:center;
    font-size: 24px;
    font-weight: 500;
    color: #ffffff;
    background:rgba(0,0,0,0.6);
    @media (max-width: 768px){
        font-size: 14px;
        padding : 8px 10px;
    }
`

const ContentWrap = styled.div`
    padding : 48px;
    display: flex;
    flex-direction: column;
`
const Function = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 20px 10px;
    @media (max-width: 768px){
        padding: 0px 2px 14px;
    }
`
const FunctionTitle = styled.div`
    font-size: 20px;
    width:auto;
    color: #ffffff;
    font-weight: 500;
    text-align:center;
    @media (max-width: 768px){
        font-size: 14px;
        width:auto;
    }
`
const FunctionPicture = styled.div`
    width: 140px;
    height: 140px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 75%;
    background-image: ${props => `url(${props.picture})`};
    border-radius: 100%;
    @media (max-width: 768px){
        width: 80px;
        height: 80px;
    }
`

const FunctionWrap = styled.div`
    display: flex;
    justify-content: space-between;
    width: 90%;
    padding: 32px;
    @media (max-width: 768px){
        padding: 0 4px;
    }
`


// WEBPACK FOOTER //
// ./src/Contact.js